package modysy

import modysy.datastructures.Vector2
import modysy.model._
import modysy.simulation.Behaviours
import modysy.simulation.pp._
import modysy.simulation.pp.SuccessConditions.LevelResult.LevelResult
import modysy.tools._
import modysy.view.Color

import scala.collection.mutable
import scala.collection.mutable.ListBuffer

class Level1(val width: Int, val height: Int) extends Level {

  override val time: Int = 10000

  override var portals: Seq[(Portal, Portal)] = Seq()

  /**
    * Define the rules of the population protocol for this level.
    */
  override val protocol: PopulationProtocol = new PopulationProtocol

  val states: Array[State] = Array(
    State(
      "+L",
      Color.Green,
      Output("Pro"),
      Behaviours.chasingBehaviour("-", 2)
    ),
    State("-L", Color.Red, Output("Con"), Behaviours.chasingBehaviour("+", 2)),
    State(
      "+",
      Color.Green_Light,
      Output("Pro"),
      Behaviours.fleeingBehaviour("-L", 2)
    ),
    State(
      "-",
      Color.Red_Light,
      Output("Con"),
      Behaviours.fleeingBehaviour("+L", 2)
    )
  )

  protocol.addRuleSymmetric(Rule(states(0), states(1), states(2), states(3)))
  protocol.addRuleSymmetric(
    simulation.pp.Rule(states(0), states(3), states(2), states(0))
  )
  protocol.addRuleSymmetric(
    simulation.pp.Rule(states(2), states(1), states(1), states(3))
  )

  /**
    * Define the winning condition for this level.
    */
  private val successCondition =
    SuccessConditions.convertThemAll(states(0).output)

  override val innerField: InnerField =
    new RectangularInnerField((0, 0), (width, height))

  override def availableTools(controller: GameController): List[Tool] = {
    val tool = new NudgeTool(controller)
    tool.uses = 2

    List(
      tool
    )
  }

  /**
    *
    * @return the current result of the level
    */
  override def result: LevelResult = successCondition(objects)

  /**
    * Add all initial objects to the buffered list.
    */
  override var objects: ListBuffer[GameObject] = new ListBuffer[GameObject]

  /**
    * Reset objects to restart level.
    */
  override def resetObjects(): Unit = {
    objects.clear()
    objects ++= makeBorders ++= getInitialAgents
  }

  /**
    * Define here the overall measurements of the canvas.
    *
    * @return
    */
  private def makeBorders = {
    val verticalBox = Box(2, height)
    val horizontalBox = Box(width, 2)
    val makeBorder = (box: Box, position: Vector2) =>
      new FixedShapeGameObject(
        new RigidBody(
          Transform.translate(position),
          Velocity.zero,
          Material(density = Double.PositiveInfinity, restitution = 1),
          box
        ),
        "purple"
    )
    List(
      makeBorder(horizontalBox, Vector2(width.toDouble / 2, 1)),
      makeBorder(horizontalBox, Vector2(width.toDouble / 2, height - 1)),
      makeBorder(verticalBox, Vector2(1, height.toDouble / 2)),
      makeBorder(verticalBox, Vector2(width - 1, height.toDouble / 2))
    )
  }

  /**
    * Define here all agents for the initial game setup.
    *
    * @return
    */
  private def getInitialAgents: ListBuffer[GameObject] = {
    val orientation: Double = 3.0 //number between 0 and 2*Pi
    val angular: Double = 0.0
    val agentMaterial: Material = Material(1, 1)

    val initialAgents: ListBuffer[GameObject] = ListBuffer[GameObject](
      new Agent(
        new RigidBody(
          new Transform(Vector2(300, 600), orientation),
          new Velocity(0.7 * Vector2(0, 0), angular),
          agentMaterial,
          Circle(states(0).deducedAgentRadius)
        ),
        states(2)
      ),
      new Agent(
        new RigidBody(
          new Transform(Vector2(900, 600), orientation),
          new Velocity(0.7 * Vector2(0, 0), angular),
          agentMaterial,
          Circle(states(3).deducedAgentRadius)
        ),
        states(3)
      )
    )
    initialAgents
  }

  /**
    * Display level specific messages to inform the player of something.
    */
  override def displayMessages(): Unit = {}

  var dialog1 = new Dialog(
    new Vector2(120, 250),
    """The box at the top is your Toolbox! The hand thing is called Nudge Tool. As the name implies, it gives a small boost to the nearest circle. The goal of this level is to keep at least one green from colliding with red circle.\n Good luck!""",
    180,
    -1,
    "top"
  )
  var dialog2 = new Dialog(
    new Vector2(width - 500, 150),
    "Dialog-Box with cooldown 3s",
    200,
    3000
  )

  override var dialogs = ListBuffer(dialog1, dialog2)
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/Level1.scala